<template>
  <div v-if="!(hideOnFail && fail)" class="nio-image" :style="wrapperStyle" v-on="listeners">
    <img
      v-if="!fail"
      :src="realSrc ?? ''"
      :class="['img', imgCls,externalImgClass]"
      @error="imgLoadFail"
    />
    <img
      v-else-if="fail"
      :class="['img', 'default-img', externalFailImgClass, 'img__mode-aspectfit']"
      :src="defaultSrc"
    />
  </div>
</template>

<script setup>
import { isTpad } from 'busComponent/src/utils'
const listeners = useListeners()
const props = defineProps({
  src: {
    type: String,
    default: undefined,
  },
  mode: {
    type: String,
    default: undefined,
  },
  rePlaceAssets: {
    type: Boolean,
    default: false,
  },
  needDefault: {
    type: Boolean,
    default: true,
  },
  /**
   * 默认占位图
   */
  defaultSrc: {
    type: String,
    default:
      'https://cdn-fx.nio.com/fx/configurator-website-3D/whZGhASNNvKK4JUkBSEQe/icon_logo.png',
  },
  /**
   * 图片加载失败时是否隐藏整个组件
   */
  hideOnFail: {
    type: Boolean,
    default: false,
  },
  wrapperStyle:{
    type: Object,
    default: ()=>{}
  },
  externalImgClass: {
    type: [String, Array],
    default: undefined,
  },
  externalFailImgClass: {
    type: [String, Array],
    default: undefined,
  },
})
const { src, mode, defaultSrc, needDefault, rePlaceAssets, hideOnFail } = toRefs(props)
const realSrc = ref(src.value)
const fail = ref(false)
watch(
  src,
  (newValue, oldValue) => {
    if (rePlaceAssets.value && isTpad) {
      // realSrc.value = newValue.replace('https://','assets://config/')
    } else {
      realSrc.value = newValue
    }
    if (newValue !== oldValue) {
      fail.value = false
    }
  },
  {
    immediate: true,
  }
)
const imgCls = computed(
  () =>
    'img__mode-' +
    (mode.value || 'scaleToFill').toLowerCase().replace(/\s/g, '')
)
const imgLoadFail = () => {
  if (!needDefault.value) return
  realSrc.value = defaultSrc.value
  fail.value = true
}
</script>

<style lang="scss" scoped>
.nio-image {
  width: 100%;
  height: 100%;
}
.img {
  width: 100%;
  height: 100%;
}
.img-no-size{
  width:auto;
  height:auto;
}
.img__widthfix {
  height: 100%;
}

.img__mode-scaletofill {
  /* object-fit: contain; */
  width: 100%;
  height: 100%;
}

.img__mode-aspectfit {
  object-fit: contain;
  max-width: 100%;
  max-height: 100%;
}
.img__mode-aspectfill {
  object-fit: cover;
  width: 100%;
  height: 100%;
}

.img__mode-widthfix {
  width: 100%;
  height: auto;
}

.img__mode-heightfix {
  height: 100%;
  width: auto;
}
</style>
